import { gql } from '@apollo/client';
import { ProductFragment } from './Product';
import { AppFragment } from './App';
import { MenuVariantFragment } from './Variant';

export const MenuFragment = gql`
  fragment MenuFragment on Menu {
    mmId
    name
    neverPublished
    busyUntil
    apps {
      ...AppFragment
    }
    categories {
      mmId
      category
      productIds
      description
      displayOrder
      idsByApp {
        app {
          id
          name
        }
        id
      }
    }
    products {
      ...ProductFragment
    }
    variants {
      ...MenuVariantFragment
    }
    surcharge {
      amount
      type
    }
  }

  ${AppFragment}
  ${ProductFragment}
  ${MenuVariantFragment}
`;

export const PublishMenuMutation = gql`
  mutation PublishMenu($venueId: ID!, $appId: ID!) {
    publishMenu(locationId: $venueId, appId: $appId)
  }
`;

export const SaveMenuMutation = gql`
  mutation SaveMenu($venueId: ID!, $newMenu: MenuInput!, $isSaveOnly: Boolean!) {
    saveMenu(locationId: $venueId, newMenu: $newMenu, isSaveOnly: $isSaveOnly) {
      menus {
        ...MenuFragment
      }
      failedAppIds
      impactedApps {
        ...AppFragment
      }
    }
  }

  ${AppFragment}
  ${MenuFragment}
`;

export const UpdateMenuLinkMutation = gql`
  mutation UpdateMenuLink($venueId: ID!, $appId: ID!, $surcharge: SurchargeInput, $skipFetch: Boolean) {
    updateMenuLink(locationId: $venueId, appId: $appId, surcharge: $surcharge, skipFetch: $skipFetch) {
      ...MenuFragment
    }
  }

  ${MenuFragment}
`;
